import { TRPCResponse } from '../../types';

const pendingRequests = new Map<string, Promise<unknown>>();

const makeKey = (params: RequestInit & { url: string }): string => {
  const { url, method = 'GET', body, headers } = params;

  return JSON.stringify({ url, method, body, headers });
};

export const fetchWithoutDuplicates = async <TData>(
  params: RequestInit & { url: string },
): Promise<TRPCResponse<TData> | null> => {
  const key = makeKey(params);

  if (pendingRequests.has(key)) {
    return pendingRequests.get(key) as Promise<TRPCResponse<TData>>;
  }

  const promise = (async () => {
    try {
      const response = await fetch(params.url, params);
      if (!response.ok) {
        throw new Error(
          `Fetch failed: ${response.status} ${response.statusText}`,
        );
      }

      // иногда ответ может быть пустым response.json() падает с ошибкой в таком случае
      const text = await response.text();

      if (!text) {
        return null;
      }

      let data: TRPCResponse<TData>;
      try {
        data = JSON.parse(text) as TRPCResponse<TData>;
      } catch (error) {
        console.error('Failed to parse JSON. Raw body:', text);
        throw error;
      }

      if (data?.error) {
        const { code, message } = data.error;
        console.error(`RPC error ${code}: ${message}`, data.error.data);

        return null;
      }

      return data ?? null;
    } finally {
      pendingRequests.delete(key);
    }
  })();

  pendingRequests.set(key, promise);

  return promise;
};
